var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "import-summary-container" },
    _vm._l(_vm.fields, function(field) {
      return _c(
        "div",
        { key: field.label, staticClass: "summary-field-container" },
        [
          !field.pngSrc
            ? _c("v-icon", { attrs: { size: field.size } }, [
                _vm._v(_vm._s(field.icon))
              ])
            : _vm._e(),
          _vm._v(" "),
          field.pngSrc
            ? _c("img", {
                style: { width: field.width, height: field.height },
                attrs: { src: field.pngSrc }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("p", [
            _vm._v("\n            " + _vm._s(field.label) + ":\n        ")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("\n            " + _vm._s(field.value) + "\n        ")
          ])
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8e730508", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e730508","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/Data/Imports/ImportsSummary.vue
// module id = null
// module chunks = 